export function getFormattedNumber(number: number | undefined) {
  if (number === undefined) {
    return '0';
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal'
  });

  return formatter.format(number);
}

export function formatDate(d: string) {
  const date = new Date(d);

  const formatter = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC'
  });

  return formatter.format(date);
}

/**
 * Add the word Collection to title if it doesn't already have it in it somewhere (case insensitive, includes 'Collections' as well)
 * @param title - The title to add Collection to
 * @returns The title with Collection added if it doesn't already exist
 */
export const addCollectionToTitle = (title: string) => {
  return /\bcollections?\b/i.test(title) ? title : title + ' Collection';
};
